/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BudgetAdjustmentFilterDTO } from './budgetAdjustmentFilterDTO';


export interface RecommendedBudgetAdjustmentRequestDTO { 
    /**
     * Measured client identifier required for the optimization request.
     */
    clientId: number;
    /**
     * Brand identifier required for the optimization request.
     */
    brandId: number;
    /**
     * Conversion type used to scope the recommendation and pull the correct dashboard data.
     */
    conversion_type: string;
    /**
     * Optimization plan identifier used as the baseline for the recommendation.
     */
    planId: number;
    /**
     * Reference period start date in ISO-8601 date format.
     */
    dateStart: string;
    /**
     * Reference period end date in ISO-8601 date format.
     */
    dateStop: string;
    /**
     * Optional table dimension to use when grouping the recommendation output.
     */
    tableDimension?: RecommendedBudgetAdjustmentRequestDTO.TableDimensionEnum;
    /**
     * Optional view type controlling whether the comparison uses ROAS or CPO metrics.
     */
    viewType?: RecommendedBudgetAdjustmentRequestDTO.ViewTypeEnum;
    filter?: BudgetAdjustmentFilterDTO;
    /**
     * Optional case-insensitive substring search applied to the current tableDimension formatted value (tactic, channel, segment, or conversion type). Does not search budget or metric columns.
     */
    search?: string;
}
export namespace RecommendedBudgetAdjustmentRequestDTO {
    export type TableDimensionEnum = 'channel' | 'segment' | 'tactic' | 'conversionType' | 'all';
    export const TableDimensionEnum = {
        Channel: 'channel' as TableDimensionEnum,
        Segment: 'segment' as TableDimensionEnum,
        Tactic: 'tactic' as TableDimensionEnum,
        ConversionType: 'conversionType' as TableDimensionEnum,
        All: 'all' as TableDimensionEnum
    };
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
}


